import { Grid, Typography, styled } from "@mui/material";

import Coin from "./Coin";
import NumberFormats from "components/NumberFormats";

export function SpotWalletBoxMobile({ coin, headers, onClick }) {
  return (
    <WalletCardWrapper onClick={() => onClick(coin)}>
      <Grid container>
        <GridCoin item xs={2}>
          <Coin coin={coin} />
        </GridCoin>

        <Grid item xs={10}>
          <Grid container>
            {headers?.map((head) => (
              <Grid item xs={6} marginBottom={2}>
                <Typography variant="subtitle2" color="text.secondary">
                  {head.title}{" "}
                  <Typography
                    variant="h5"
                    fontWeight={head.bold ? 600 : 400}
                    color="text.main"
                  >
                    <NumberFormats value={coin[head?.key]} />
                  </Typography>
                </Typography>

                {/* <Typography
                  variant="subtitle1"
                  color="text.alternate"
                  paddingLeft={0.5}
                >
                  {coin[head?.key + "Comment"]}
                </Typography> */}
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </WalletCardWrapper>
  );
}

const GridCoin = styled(Grid)(() => ({
  ".MuiBox-root ": {
    display: "block",
  },
}));

const WalletCardWrapper = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1.8),
  display: "flex",
  alignItems: "flex-start",
  border: `1px solid ${theme.palette.modules.border}`,
  background: theme.palette.background.primaryGradient,
  boxShadow: " 0 0 5px 2px rgb(113 208 244 / 5%)",
  marginBottom: theme.spacing(1.25),
  borderRadius: theme.spacing(1.25),
  position: "relative"
}));

export default SpotWalletBoxMobile;
